<template>
  <v-layout
    row
    wrap
  >
    <v-flex xs12>
      <v-card class="max-shadow">
        <v-toolbar
          color="white"
          flat
        >
          <v-toolbar-title class="blue-grey--text text--darken-3">
            Location Settings
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn
              :disabled="locationDisabled(location.subscriptionStatus)"
              color="primary"
              flat
              @click="updateActive"
            >
              {{ getStatusText }}
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <location
          :location="location"
          class="px-3 py-3"
          @change="updateLocation"
        />
      </v-card>
      <v-snackbar
        v-model="snackbar"
        :color="snackbarColor"
        :timeout="0"
        bottom
      >
        {{ snackbarMessage }}
        <v-btn
          flat
          @click.native="snackbar = false"
        >
          Close
        </v-btn>
      </v-snackbar>
    </v-flex>
  </v-layout>
</template>
<script>
import _get from 'lodash/get';
import _omit from 'lodash/omit';
import { database } from '@/firebase';

import location from '@/components/common/Location';

export default {
  name: 'LocationSettings',
  components: {
    location
  },
  data() {
    return {
      location: {},

      firebaseListeners: {},

      snackbarMessage: '',
      snackbarColor: 'primary',
      snackbar: false
    };
  },
  computed: {
    locationRef() {
      const lid = _get(this.$store.state.VMS, 'lid');
      // return null if the location ID is not yet set
      if (!lid) return null;

      return database.ref(`vms/locations/${lid}`);
    },
    getStatusText() {
      return this.location.active ? 'Deactivate' : 'Activate';
    }
  },
  watch: {
    locationRef: {
      handler(val) {
        if (!val) return;

        if (this.firebaseListeners.locationQuery) {
          val.off('value', this.firebaseListeners.locationRef);
          this.firebaseListeners = {};
        }

        this.fetchLocation();
      },
      immediate: true
    }
  },
  beforeDestroy() {
    this.locationRef.off('value', this.firebaseListeners.locationRef);
  },
  methods: {
    fetchLocation() {
      const locationQuery = this.locationRef.on('value', locationSnapshot => {
        if (!locationSnapshot.val()) return;
        const locationValues = locationSnapshot.val();
        this.location = locationValues;
      });
      this.firebaseListeners.locationQuery = locationQuery;
    },

    locationDisabled(status) {
      return !(status === 'trial' || status === 'live');
    },

    updateLocation(data) {
      const locationData = data;
      const striped = _omit(locationData, ['sid', 'subscriptionStatus']);
      this.locationRef.update(striped).catch(error => {
        this.snackbarMessage = error;
        this.snackbarColor = 'error';
        this.snackbar = true;
      });
    },
    updateActive() {
      this.location.active = this.location.active ? false : true;
      this.locationRef.update({ active: this.location.active });
    }
  }
};
</script>

